module.exports = {"TXTWCL_Login_to_bet":{"id":"TXTWCL_Login_to_bet","defaultMessage":"Einloggen und wetten","track":"Login to Bet"}}